/**
 * SyM Asociados - Performance Mobile Optimizations
 * Reduces TBT and INP on mobile by:
 * 1. Disabling scroll-synergy parallax/zoom on mobile (INP/TBT reduction)
 * 2. Deferring initHeaderHeight to idle time (TBT reduction)
 * 3. Scheduling non-critical tasks after LCP
 */
(function() {
  'use strict';

  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  // Disable scroll-synergy observer on mobile to reduce scroll jank and TBT
  if (isMobile) {
    // Override initScrollSynergy to disable parallax/zoom on mobile
    // but keep crab-scroll (seamless-scroll) which is CSS-only
    document.addEventListener('DOMContentLoaded', function() {
      // Remove scroll-synergy from parallax and zoom-in elements on mobile
      var parallaxEls = document.querySelectorAll(
        '.behavior--parallax.scroll-synergy, .behavior--zoom-in.scroll-synergy'
      );
      parallaxEls.forEach(function(el) {
        el.classList.remove('scroll-synergy');
        el.style.transform = 'none';
        el.style.willChange = 'auto';
      });
    }, { once: true });
  }

  // Defer non-critical scroll listeners until after first user interaction
  // This improves INP by keeping the main thread free during initial page load
  var scrollInitialized = false;
  function deferScrollInit() {
    if (scrollInitialized) return;
    scrollInitialized = true;
    // Re-initialize scroll synergy for desktop after idle
    if (!isMobile && typeof webvista !== 'undefined' && webvista.initScrollSynergy) {
      requestIdleCallback
        ? requestIdleCallback(function() { webvista.initScrollSynergy(); }, { timeout: 2000 })
        : setTimeout(function() { webvista.initScrollSynergy(); }, 500);
    }
  }

  // Only init scroll effects after first scroll or click to improve INP
  window.addEventListener('scroll', deferScrollInit, { once: true, passive: true });
  window.addEventListener('pointerdown', deferScrollInit, { once: true, passive: true });

})();
